import SubmissionTranslator from "../../../utils/SubmissionTranslator";
import { baseColumnNameAliases } from "./BaseEncounterClaim";

const translator = new SubmissionTranslator("pharmacy_encounter");

// Order of columnSchema must match order of columnDetails
export const columnSchema = {
  contracted_entity_id: null,
  date_of_service: null,
  date_prescribed: null,
  ndc: null,
  quantity: null,
  rx_number: null,
  service_provider_id: null,
  prescriber_id: null,
  wholesaler_invoice_number: null,
  payer_bin: null,
  payer_pcn: null,
  ship_to_location: null,
  ship_to_date: null,
  account_340b: null,
  product_serialization_number: null,
  fill_number: null,
  // start encounter fields
  encounter_billing_service_provider_id: null,
  encounter_date_of_service: null,
  encounter_rendering_physician_id: null,
  encounter_hcpcs_code: null,
  encounter_hcpcs_code_modifier_1: null,
  encounter_hcpcs_code_modifier_2: null,
  encounter_hcpcs_code_modifier_3: null,
  encounter_hcpcs_code_modifier_4: null,
  encounter_diagnosis_code_primary: null,
  encounter_diagnosis_code_2: null,
  encounter_diagnosis_code_3: null,
  encounter_diagnosis_code_4: null,
  encounter_diagnosis_code_5: null,
  encounter_diagnosis_code_6: null,
  encounter_diagnosis_code_7: null,
  encounter_diagnosis_code_8: null,
  encounter_diagnosis_code_9: null,
  encounter_diagnosis_code_10: null,
  encounter_place_of_service_code: null,
  // hashed fields
  formatted_rx_number: null,
};

export const columnDetails = [
  {
    name: "contracted_entity_id",
    title: translator.getTitle("contracted_entity_id"),
    label: translator.getLabel("contracted_entity_id"),
    description: translator.getDescription("contracted_entity_id"),
    required: true,
    order: 1,
  },
  {
    name: "date_of_service",
    title: translator.getTitle("date_of_service"),
    label: translator.getLabel("date_of_service"),
    description: translator.getDescription("date_of_service"),
    required: true,
    order: 2,
  },
  {
    name: "date_prescribed",
    title: translator.getTitle("date_prescribed"),
    label: translator.getLabel("date_prescribed"),
    description: translator.getDescription("date_prescribed"),
    required: true,
    order: 3,
  },
  {
    name: "ndc",
    title: translator.getTitle("ndc"),
    label: translator.getLabel("ndc"),
    description: translator.getDescription("ndc"),
    required: true,
    order: 4,
  },
  {
    name: "quantity",
    title: translator.getTitle("quantity"),
    label: translator.getLabel("quantity"),
    description: translator.getDescription("quantity"),
    required: true,
    order: 5,
  },
  {
    name: "rx_number",
    title: translator.getTitle("rx_number"),
    label: translator.getLabel("rx_number"),
    description: translator.getDescription("rx_number"),
    required: true,
    order: 6,
  },

  {
    name: "service_provider_id",
    title: translator.getTitle("service_provider_id"),
    label: translator.getLabel("service_provider_id"),
    description: translator.getDescription("service_provider_id"),
    required: true,
    order: 7,
  },
  {
    name: "prescriber_id",
    title: translator.getTitle("prescriber_id"),
    label: translator.getLabel("prescriber_id"),
    description: translator.getDescription("prescriber_id"),
    required: false,
    order: 8,
  },
  {
    name: "wholesaler_invoice_number",
    title: translator.getTitle("wholesaler_invoice_number"),
    label: translator.getLabel("wholesaler_invoice_number"),
    description: translator.getDescription("wholesaler_invoice_number"),
    required: false,
    order: 9,
  },
  {
    name: "payer_bin",
    title: translator.getTitle("payer_bin"),
    label: translator.getLabel("payer_bin"),
    description: translator.getDescription("payer_bin"),
    required: false,
    order: 10,
  },
  {
    name: "payer_pcn",
    title: translator.getTitle("payer_pcn"),
    label: translator.getLabel("payer_pcn"),
    description: translator.getDescription("payer_pcn"),
    required: false,
    order: 11,
  },
  {
    name: "ship_to_location",
    title: translator.getTitle("ship_to_location"),
    label: translator.getLabel("ship_to_location"),
    description: translator.getDescription("ship_to_location"),
    required: false,
    order: 12,
  },
  {
    name: "ship_to_date",
    title: translator.getTitle("ship_to_date"),
    label: translator.getLabel("ship_to_date"),
    description: translator.getDescription("ship_to_date"),
    required: false,
    order: 13,
  },
  {
    name: "account_340b",
    title: translator.getTitle("account_340b"),
    label: translator.getLabel("account_340b"),
    description: translator.getDescription("account_340b"),
    required: false,
    order: 14,
  },
  {
    name: "product_serialization_number",
    title: translator.getTitle("product_serialization_number"),
    label: translator.getLabel("product_serialization_number"),
    description: translator.getDescription("product_serialization_number"),
    required: false,
    order: 15,
  },
  {
    name: "fill_number",
    title: translator.getTitle("fill_number"),
    label: translator.getLabel("fill_number"),
    description: translator.getDescription("fill_number"),
    required: false,
    order: 16,
  },
  {
    name: "encounter_billing_service_provider_id",
    title: translator.getTitle("encounter_billing_service_provider_id"),
    label: translator.getLabel("encounter_billing_service_provider_id"),
    description: translator.getDescription("encounter_billing_service_provider_id"),
    required: false,
    order: 17,
  },
  {
    name: "encounter_date_of_service",
    title: translator.getTitle("encounter_date_of_service"),
    label: translator.getLabel("encounter_date_of_service"),
    description: translator.getDescription("encounter_date_of_service"),
    required: false,
    order: 18,
  },
  {
    name: "encounter_rendering_physician_id",
    title: translator.getTitle("encounter_rendering_physician_id"),
    label: translator.getLabel("encounter_rendering_physician_id"),
    description: translator.getDescription("encounter_rendering_physician_id"),
    required: false,
    order: 19,
  },
  {
    name: "encounter_hcpcs_code",
    title: translator.getTitle("encounter_hcpcs_code"),
    label: translator.getLabel("encounter_hcpcs_code"),
    description: translator.getDescription("encounter_hcpcs_code"),
    required: false,
    order: 20,
  },
  {
    name: "encounter_hcpcs_code_modifier_1",
    title: translator.getTitle("encounter_hcpcs_code_modifier_1"),
    label: translator.getLabel("encounter_hcpcs_code_modifier_1"),
    description: translator.getDescription("encounter_hcpcs_code_modifier_1"),
    required: false,
    order: 21,
  },
  {
    name: "encounter_hcpcs_code_modifier_2",
    title: translator.getTitle("encounter_hcpcs_code_modifier_2"),
    label: translator.getLabel("encounter_hcpcs_code_modifier_2"),
    description: translator.getDescription("encounter_hcpcs_code_modifier_2"),
    required: false,
    order: 22,
  },
  {
    name: "encounter_hcpcs_code_modifier_3",
    title: translator.getTitle("encounter_hcpcs_code_modifier_3"),
    label: translator.getLabel("encounter_hcpcs_code_modifier_3"),
    description: translator.getDescription("encounter_hcpcs_code_modifier_3"),
    required: false,
    order: 23,
  },
  {
    name: "encounter_hcpcs_code_modifier_4",
    title: translator.getTitle("encounter_hcpcs_code_modifier_4"),
    label: translator.getLabel("encounter_hcpcs_code_modifier_4"),
    description: translator.getDescription("encounter_hcpcs_code_modifier_4"),
    required: false,
    order: 24,
  },
  {
    name: "encounter_diagnosis_code_primary",
    title: translator.getTitle("encounter_diagnosis_code_primary"),
    label: translator.getLabel("encounter_diagnosis_code_primary"),
    description: translator.getDescription("encounter_diagnosis_code_primary"),
    required: false,
    order: 25,
  },
  {
    name: "encounter_diagnosis_code_2",
    title: translator.getTitle("encounter_diagnosis_code_2"),
    label: translator.getLabel("encounter_diagnosis_code_2"),
    description: translator.getDescription("encounter_diagnosis_code_2"),
    required: false,
    order: 26,
  },
  {
    name: "encounter_diagnosis_code_3",
    title: translator.getTitle("encounter_diagnosis_code_3"),
    label: translator.getLabel("encounter_diagnosis_code_3"),
    description: translator.getDescription("encounter_diagnosis_code_3"),
    required: false,
    order: 27,
  },
  {
    name: "encounter_diagnosis_code_4",
    title: translator.getTitle("encounter_diagnosis_code_4"),
    label: translator.getLabel("encounter_diagnosis_code_4"),
    description: translator.getDescription("encounter_diagnosis_code_4"),
    required: false,
    order: 28,
  },
  {
    name: "encounter_diagnosis_code_5",
    title: translator.getTitle("encounter_diagnosis_code_5"),
    label: translator.getLabel("encounter_diagnosis_code_5"),
    description: translator.getDescription("encounter_diagnosis_code_5"),
    required: false,
    order: 29,
  },
  {
    name: "encounter_diagnosis_code_6",
    title: translator.getTitle("encounter_diagnosis_code_6"),
    label: translator.getLabel("encounter_diagnosis_code_6"),
    description: translator.getDescription("encounter_diagnosis_code_6"),
    required: false,
    order: 30,
  },
  {
    name: "encounter_diagnosis_code_7",
    title: translator.getTitle("encounter_diagnosis_code_7"),
    label: translator.getLabel("encounter_diagnosis_code_7"),
    description: translator.getDescription("encounter_diagnosis_code_7"),
    required: false,
    order: 31,
  },
  {
    name: "encounter_diagnosis_code_8",
    title: translator.getTitle("encounter_diagnosis_code_8"),
    label: translator.getLabel("encounter_diagnosis_code_8"),
    description: translator.getDescription("encounter_diagnosis_code_8"),
    required: false,
    order: 32,
  },
  {
    name: "encounter_diagnosis_code_9",
    title: translator.getTitle("encounter_diagnosis_code_9"),
    label: translator.getLabel("encounter_diagnosis_code_9"),
    description: translator.getDescription("encounter_diagnosis_code_9"),
    required: false,
    order: 33,
  },
  {
    name: "encounter_diagnosis_code_10",
    title: translator.getTitle("encounter_diagnosis_code_10"),
    label: translator.getLabel("encounter_diagnosis_code_10"),
    description: translator.getDescription("encounter_diagnosis_code_10"),
    required: false,
    order: 34,
  },
  {
    name: "encounter_place_of_service_code",
    title: translator.getTitle("encounter_place_of_service_code"),
    label: translator.getLabel("encounter_place_of_service_code"),
    description: translator.getDescription("encounter_place_of_service_code"),
    required: false,
    order: 35,
  },
];

export const computedColumns = ["formatted_rx_number"];

export const tableHeaders = columnDetails.sort((a, b) => a.order - b.order).map((col) => col.name);
export const sortedColumnDetails = columnDetails.sort((a, b) => a.order - b.order);
export const required = columnDetails.filter((col) => col.required).map((col) => col.name);
export const notRequired = columnDetails.filter((col) => !col.required).map((col) => col.name);

export const isRequiredField = (column) => required.includes(column);

// Pharmacy-specific column name aliases merged with base encounter aliases
export const columnNameAliases = {
  // Import all base aliases (encounter fields + common fields)
  ...baseColumnNameAliases,

  // Pharmacy-specific field aliases
  contracted_entity_id: [
    "Contracted Entity ID",
    "Contracted Entity",
    "OPA Code",
    "HRSA #",
    "Entity ID",
    "contracted_entity_id",
    "CE ID",
    "340B ID",
  ],
  date_prescribed: [
    "Date Prescribed",
    "Rx Written Date",
    "date_prescribed",
    "Written Date",
    "Date Prescription Written",
    "Prescribed Date",
    "Date Written",
    "RX-Date Written",
    "Script Written Date",
    "Date RxWritten",
    "Date Rx Written",
  ],
  rx_number: [
    "Rx number",
    "Prescription Number",
    "Service Reference Number",
    "Rx Nbr",
    "rx_number",
    "Prescription_Number",
    "Rx #",
    "RX NBR",
  ],
  prescriber_id: [
    "Prescriber ID",
    "prescriber npi",
    "Prescriber DEA",
    "prescriber_id",
    "PrescriberNPIorDEA",
    "Prescriber NPI Or Dea",
  ],
  payer_bin: ["Payer BIN", "BIN", "payer_bin"],
  payer_pcn: ["Payer PCN", "PCN", "payer_pcn"],
  ship_to_location: ["Ship to location", "Ship location", "ship_to_location"],
  ship_to_date: ["Ship to date", "Ship date", "ship_to_date"],
  account_340b: ["340b Account", "Account 340b", "account_340b", "340b_account"],
  product_serialization_number: [
    "Product Serialization Number",
    "Serial Number",
    "product_serialization_number",
    "product_serial_num",
    "product_serialization_num",
    "serialization_number",
    "serial_number",
  ],
  fill_number: ["Fill Number", "fill_number", "fill_num", "Fill Num"],
};
